import { Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { PageService } from 'src/app/services/shared/page.service';
import { BehaviorSubject, Observable, Subscription, map, of } from 'rxjs';
import { Router } from '@angular/router';
import { ChartType } from 'angular-google-charts';
import {  MessagesService } from 'src/app/services/service.index';
import { DxDropDownButtonComponent } from 'devextreme-angular';
import { MicroapplicationService } from 'src/app/services/microapplications/_services/microapplication.service';
import { MicroApplication, Widget } from 'src/app/services/microapplications/_models/microapplication.model';
import { AuthService } from 'src/app/models/auth/_services/auth.service';
import { Chartgoogle  } from 'src/app/models/auth/_models/user.model';
import { ActionResult } from 'src/app/models/auth/_models/action-result';
import { ChangeDetectorRef } from '@angular/core';
interface Board {
  id: string;
  cod_dash: string;
  nom_dash: string;
  tit_dash: string;
  cod_usua: string;
  dsb_publ: string;
}

interface Pizza {
  id: string;
  name: string;
  price: number;
}

interface arrayMerge {
  data: any[];
  property: string;
}

const getPizzas$: Observable<Pizza[]> = of([
  { id: "j8P9sz", name: "Pepperoni", price: 899 },
  { id: "tMot06", name: "Supreme", price: 999 },
  { id: "x9sD3g", name: "Sizzler", price: 899 },
]);


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {
  public sessionData = JSON.parse(sessionStorage.getItem('sessionData') || '{}');
  @ViewChild('chartTaks', { static: false }) chartComponent: any;
  public codUser: string;
  // @ViewChild("chart") chart: ChartComponent | undefined;
  @ViewChild(DxDropDownButtonComponent) dropDown: DxDropDownButtonComponent | undefined;
  private microapplicationService: MicroapplicationService
  public chartOptions: Partial<any>;
  public favoriteListArr: any[] = [];
  public subscription: Subscription = new Subscription;
  public windowTopLeftPosition: any = { x: 0, y: 0 };
  public showOptionsFav: boolean = false;
  public favoriteSelected: any;
  TaskSummary$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  options = {};
  width = 550;
  height = 400;
  public tooltip: any = {
    enabled: false,
    opacity: 0
  };
  public border: any = {
    cornerRadius: 50, opacity: 0.8, with: 20
  };
  public boards: any[] = [];
  public boardsTop: any[] = [];
  widgets:  Observable<ActionResult<MicroApplication[]>>;
  widgetsResult:  Observable<MicroApplication[]>;
  browserName = '';
  bars = "";
  filtersItemPor: any = [];
  public defaultIconForm = 'fa-solid fa-file-lines';
  filtroQbeForms: { paginacion: { registrosporpagina: number; }; };
  body: { estado: string; evento: string; };
  licenciamessage: any;
  chartgoogle: Chartgoogle [] = [];
  chartgoogletask: Chartgoogle 
  statusTaskG: Chartgoogle ;
  pizzas$: Observable<Pizza[]>;
  type: any;
  conpany: any;
  user_code: any;
  countask: any;
  mostrarChat: boolean = false;


  constructor(
    private _pageService: PageService,

    private router: Router,
    private _messagesService: MessagesService,
    private authService: AuthService,
    public microApps: MicroapplicationService,
    private el: ElementRef, private renderer: Renderer2,
    private cdRef: ChangeDetectorRef
  ) {


    
    this.codUser = '';
    this.chartOptions = {
      series: ['100'],
      colors: ["#00569d"],
      chart: {
        height: 250,
        type: 'radialBar'
      },
      plotOptions: {
        radialBar: {
          hollow: {
            margin: 0,
            size: '50%',
            background: '#293450',
            dropShadow: {
              enabled: true,
              top: -1,
              left: 0,
              blur: 0,
              opacity: 0
            }
          },
          track: {
            strokeWidth: '30%',
            dropShadow: {
              enabled: true,
              top: 2,
              left: 0,
              blur: 4,
              opacity: 0.15
            }
          },

          dataLabels: {
            name: {
              offsetY: -10,
              show: true,
              color: '#fff',
              fontSize: '17px'
            },
            value: {
              formatter: function (val: { toString: () => string; }) {
                return 'En Progreso'
              },
              color: '#fff',
              fontSize: '18px',
              show: true,
            }
          }
        }
      },
      responsive: [{
        breakpoint: 1100,
        options: {
          radialBar: {
            hollow: {
              size: '40%'
            }
          }
        },
        track: {
          strokeWidth: '30%',
          dropShadow: {
            enabled: true,
            top: 2,
            left: 0,
            blur: 4,
            opacity: 0.15
          }
        },
      }
      ],
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'dark',
          type: 'vertical',
          shadeIntensity: 0.5,
          gradientToColors: ['#00569d'],
          stops: [0, 100]
        }
      },
      stroke: {
        lineCap: 'round'
      },
      labels: ['Migración'],
    };
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }


  ngOnInit(): void {

   


  
  // this.renderer.setStyle(this.el.nativeElement, 'overflow-y', 'scroll');
  this.renderer.setStyle(this.el.nativeElement, 'max-height', '100%');

  this.licenciamessage = JSON.parse(localStorage.getItem('licensemessageerror'));

     sessionStorage.setItem('Pages', JSON.stringify([]));
     this.conpany = this.sessionData.selectedCompany.code;
     this.user_code = this.sessionData.accountCode;

     this.datawidget( this.conpany);
     this.GetTaskSummary();
     this.statusTask();
    setTimeout(() => {
      if (this.licenciamessage) {
        this._messagesService.error(this.licenciamessage);
        localStorage.removeItem('licensemessageerror');
      }
      }, 2500);

 
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges(); // Forzar actualización después de cargar los datos
  }

  getWidgets() {

    this.widgetsResult = this.authService.GetWidgets().pipe(
      map((result: ActionResult<MicroApplication[]>) => result.result)
    );

  }





  widgetClick(e){
    this.router.navigate(["microapplication/microapplication-settings"], {
      queryParams: {
        pId: e.itemData.id
      },
    });
  }

  getColums(data: Widget) {

    switch (data.columns) {
      case 1:
        return "col-lg-6 col-xxl-4";
        break;
      case 2:
        return "col-lg-8 col-xxl-8";
        break;
      case 3:
        return "col-lg-12 col-xxl-12";
        break;
      default:
        return "col-lg-6 col-xxl-4";
    }

  }

  onRightClick(event: any, forma: any): void {
    this.showOptionsFav = true;
    this.windowTopLeftPosition.x = event.clientX + 'px';
    this.windowTopLeftPosition.y = event.clientY - 30 + 'px';
    this.favoriteSelected = forma;
    event.preventDefault();
  }
  deleteFavorite(event: any, forma: any): void {
    this.favoriteSelected = forma;
    event.preventDefault();
    this.showOptionsFav = false;

  }
  addListfavorite(data: any) {
    this.favoriteListArr.push(data);
    
    let indexBorad = this.boards.find(e=>e.tit_dash=='Favoritos');
    if(indexBorad) this.getDataBoard(indexBorad);

  }
  isOphelia(page: any) {
    return page.nom_fisi.includes('.odkl');
  }

  // Obtener definicion de los tableros
  getDefBoard(boards: any) {
    boards.forEach((element: Board, i: any) => {

    });
  }

  // Obtener data de un tablero
  getDataBoard(board: any, boardFather?: any) {
    let bodyRequest: any = {
      grp_type: board.typ_sele,
      filters: []
    }

    if (Object.keys(board.filters).length > 0) {
      Object.keys(board.filters).forEach(prop => {
        bodyRequest.filters.push(board.filters[prop]);
      });
    };

  }

  changeSelectionType(component: any, board: any) {
    board.typ_sele = component.item.key;
    this.getDataBoard(board);
  }

  // Guardar filtros de tablero
  saveFilter(board: any, data: any, type: any, getData?: boolean) {
    board.filters[type] = data;
    if (getData) {
      this.getDataBoard(board)
    }
  }

  // Botones de navegacion segundo filtro
  changeIndex(currentValue: any, change: any, dataSource: any, element: any) {
    if (currentValue == null) {
      element.instance.option("value", dataSource[0].key);
    }
    let currentIndex = dataSource.findIndex((e: any) => {
      return e.key == currentValue
    });
    if (change == '+') {
      if (dataSource.length == currentIndex + 1) {
        element.instance.option("value", dataSource[0].key);
      } else {
        element.instance.option("value", dataSource[currentIndex + 1].key);
      }
    } else {
      if (currentIndex == 0) {
        element.instance.option("value", dataSource[dataSource.length - 1].key);
      } else {
        element.instance.option("value", dataSource[currentIndex - 1].key);
      }
    }
  }

  // Actualizar opciones de un componente
  onContentReady(e: any) {
    e.component.option('loadPanel.enabled', false);
    this.calcHeight();
  }

  onContentReadySelect(e: any, dataSource: any) {
    e.component.option("value", dataSource[0]?.key);
  }

  customizeLabel(e: any) {
    return `${e.argumentText}\n${e.valueText}`;
  }

  log(item: any) {
    console.log(item);
  }

  // eventos
  eventHandler(board: any, idGraph: any, data: any, event: string,$event:Event) {
    $event.stopPropagation();
    let bodyRequest: any = {
      grp_type: board.typ_sele,
      filters: [],
      data: data
    }

    if (Object.keys(board.data_graph.data[0].hasOwnProperty('filters')).length > 0) {
      Object.keys(board.data_graph.data[0].filters).forEach(prop => {
        bodyRequest.filters.push(board.filters[prop]);
      });
    };
  };

  showSubDash(e: any, nameEvent: any, graph: any, board: any) {
    console.log(e, nameEvent, graph, board);
    
    if (graph.hasOwnProperty('events')) {
      if (nameEvent == 'viewdetail') {
        let boardData: any = {};
        boardData.filters = board.filters;
        graph.events.viewdetail.data.forEach((data: any) => {
          boardData.filters['subDash' + data] = { id: data, value: e.target.data[data] }
        });
        boardData.cod_dash = graph.events.viewdetail.dashbid;
        this.getDataBoard(boardData, board);
      }
    }
  }

  hideSubDash(board: any) {
    delete board.dataSubBoard;
  }

  calcWihtBar(e: any) {
    setTimeout(() => {
      if (parseFloat(window.getComputedStyle(e.component._$range[0]).width) < 20 && parseFloat(window.getComputedStyle(e.component._$range[0]).width) > 0) {
        e.component._$range[0].style.left = `calc(${e.component._$range[0].style.width} - ${20}px)`;
        e.component._$range[0].style.width = 20 + 'px';
      }
    }, 1000);
  }

  calcHeight() {
    let cards = document.querySelectorAll(".overflow-auto.scroll")
    cards.forEach((e: any) => {
      let height=0;
      e.childNodes.forEach((e: any) => {
        if(e.clientHeight && !e.classList.contains('card-text'))height = height + e.clientHeight
      })    
      let restHeight = (e.clientHeight - height) - 20
      let tables = e.querySelectorAll('.table-board-basic')
      tables.forEach((e: any) => {
        e.style.height = `${restHeight}px`
        // e.style.height = `${restHeight/tables.length}px`
        e.querySelector('.dx-datagrid-columns-separator').style.height = `${restHeight/tables.length}px`
      })
    })
  }

  mergeArray = (...arrays: arrayMerge[]) => {
    let merge: any[] = [{}];
    arrays.forEach(e => {
      let obj: any = {};
      e.data.forEach((item, i) => {
        if(merge[i]) {
          merge[i][e.property] = item; 
        } else {
          obj[e.property] = item
          merge.push(obj)
        }
      })
    })
    return merge;
  }

  formatDate = (value: string) => {
    let month = [
      'Enero',
      'Febrero',
      'Мarzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ]
    let date = new Date(value);
    return `${date.getDate()} ${month[date.getMonth()]}, ${date.getFullYear()}`
  }
  getForms() {
    if (!sessionStorage.getItem("listDeta_form")) {
      this.body = { estado: 'Idle', evento: 'OnQBE' };
      this.filtroQbeForms = { paginacion: { registrosporpagina: 0 } };

    }
    let formas = sessionStorage.getItem('List_form');
    this.body = { estado: 'Idle', evento: 'OnQBE' };
    if (!formas) {
      let filter = {
        "filtro": {
          "condition": "or",
          "rules": [
            {
              "field": 'tip_form',
              "operator": "=",
              "value": 'M'
            },
            {
              "field": 'tip_form',
              "operator": "=",
              "value": 'S'
            },
            {
              "field": 'tip_form',
              "operator": "=",
              "value": 'A'
            },
            {
              "field": 'tip_form',
              "operator": "=",
              "value": 'Q'
            },
            {
              field: 'tip_form',
              operator: '=',
              value: 'P',
            },
          ]
        }
      }

    }
  }

  datawidget(company: string): void {
    this.microApps.WidgetsList(company, this.user_code).subscribe({
      next: (resp) => {
        if (resp.isSuccessful) {
          this.chartgoogle = (resp.result || [])
            .map((item: any): Chartgoogle  | null => {
              // Determinar tipo de gráfico
              const chartType = this.getChartType(item.wid_tiwd);
  
              // Validar datos JSON
              if (!item.json || !Array.isArray(item.json) || item.json.length === 0) {
                console.warn('Gráfico con datos vacíos:', item.wid_desc);
                return null;
              }
  
              // Validar columnas
              if (!item.columnnames || !Array.isArray(item.columnnames)) {
                console.warn('Columnas inválidas para el gráfico:', item.wid_desc);
                return null;
              }
       
              // Construir el gráfico
              return {
                data: item.json,
                type: chartType,
                columnNames: item.columnnames,
                title: item.wid_desc,
                height: 550,
                width: 400
              };
            })
            .filter((chart): chart is Chartgoogle  => chart !== null);

            this.cdRef.detectChanges();
        } else {
          this._messagesService.error(resp.errorMessage);
        }
      },
      error: (error) => {
        this._messagesService.error('Error al cargar los widgets: ' + error.message);
      }
    });
  }
  GetTaskSummary() {

    this.microApps.GetTaskSummary(this.user_code,this.conpany).subscribe(resp => {
      if (resp.isSuccessful) {
       
        if (resp.result.length > 0) {
          this.countask =resp.result.length ;
        const encabezados = [ 'Fecha Frecuencia', 'Descripción', 'Usuario', 'Fecha'];

        const filas = resp.result.map((task: any) => [
          task.seg_frec,
          task.cas_desc,
          task.usu_codi,
          task.seg_flim
        ]);
        this.chartgoogletask = {
          type: 'Table',
          title: 'Tareas Programadas',
          data: filas,
          columnNames: encabezados,
          width:  '100%',
          height:  '100%',
          options: {
            showRowNumber: true,
            page: 'enable',       
            pageSize: 10,        
            width: '100%',
            height: '100%'
          }
        };
        this.cdRef.detectChanges();
      }

      }
      else {

  
      }
    });
  }

  
  statusTask(): void {


    this.microApps.GetWorkFlow(this.user_code,this.conpany).subscribe(resp => {
      if (resp.isSuccessful) {
        const result = resp.result;

        if (result && typeof result === 'object') {
          this.statusTaskG = {
            type: 'PieChart',
            title: 'Estado de Ejecución',
            columnNames: ['Tipo', 'Cantidad'],
            data: [
              ['No Ejecutado', result.notExecuted],
              ['Atrasados', result.overdue],
              ['A tiempo', result.onTime]
            ],
            options: {
              title: 'Estado de Ejecución',
              pieHole: 0.4,
              chartArea: { width: '90%', height: '80%' },
              legend: { position: 'bottom' },
            },
            width: '100%',
            height: 300
          };
          
          this.cdRef.detectChanges();
          
          // Ahora forzamos redibujo con un delay
          setTimeout(() => {
            const chartElement = this.chartComponent?.chartWrapper;
            if (chartElement?.draw) {
              chartElement.draw(); // <- esto asegura que respete el contenedor
            }
          }, 100);

          

      }
    }
      else {

  
      }
    });

  }
  private getChartType(typeCode: string): ChartType {
    switch (typeCode) {
      case 'T': return ChartType.Table;
      case 'C': return ChartType.PieChart;
      case 'A': return ChartType.AreaChart;
      case 'B': return ChartType.BarChart;
      default: return ChartType.PieChart;
    }
  }

  cerrarChat() {
    this.mostrarChat = false;
  }
}
